import { Formik, FieldArray } from 'formik'
import React from 'react'
import {
  updateActionFormList,
  updateList,
} from '../../../../../../helpers/monitoringGraphHelper'
import { Graph } from '../../../../../../model/monitoringGraph/types'
import {
  StyledForm,
  CheckboxGroup,
  StyledCheckbox,
  Button,
  InfiniteContainer,
} from '../../Styled'

type ActionProps = {
  updateGraph: () => void
  actions: Graph
  selectedActions: string[]
}
const initialValues = {
  actions: [],
}

const ActionsForm: React.FunctionComponent<ActionProps> = ({
  updateGraph,
  actions,
  selectedActions,
}) => {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      onSubmit={() => {
        updateGraph()
      }}
      render={() => (
        <StyledForm>
          <FieldArray
            name="actions"
            render={(arrayHelpers) => (
              <InfiniteContainer>
                <CheckboxGroup>
                  {actions.availableActions.map((action: any) => (
                    <div key={action}>
                      <StyledCheckbox
                        checked={!selectedActions.includes(action)}
                        onClick={(event) => {
                          updateList(event, selectedActions, action)
                          updateActionFormList(event, arrayHelpers, action)
                        }}
                        name={action}
                      >
                        {action}
                      </StyledCheckbox>
                    </div>
                  ))}
                </CheckboxGroup>
              </InfiniteContainer>
            )}
          />
          <Button name="submit" loading={false}>
            Mettre à jour
          </Button>
        </StyledForm>
      )}
    ></Formik>
  )
}

export default ActionsForm
